const Locations = {
  location: [
    {
      name: "지역전체",
      value: "",
    },
    {
      name: "강남",
      value: "&location=강남",
    },
    {
      name: "홍대",
      value: "&location=홍대",
    },
    {
      name: "건대",
      value: "&location=건대",
    },
    {
      name: "신촌",
      value: "&location=신촌",
    },
    {
      name: "대학로",
      value: "&location=대학로",
    },
    {
      name: "강북",
      value: "&location=강북",
    },
    {
      name: "신림",
      value: "&location=신림",
    },
    {
      name: "서울(기타)",
      value: "&location=서울(기타)",
    },
  ],
};

export default Locations;
